var _defs, _circle, _g, _g2, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRompecabezasPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 5,
    stdDeviation: 4,
    floodColor: "#000000",
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradOrange",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB74D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E65100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradBlue",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#64B5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1E3A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edgeHighlight",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 45,
    fill: "#E65100",
    opacity: 0.15,
    filter: "url(#glow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)",
    transform: "translate(15, 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 10 L 30 10 C 30 0, 40 0, 40 10 L 50 10 L 50 30 C 60 30, 60 40, 50 40 L 50 60 L 10 60 L 10 40 C 20 40, 20 30, 10 30 Z",
    fill: "url(#gradBlue)",
    stroke: "url(#edgeHighlight)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)",
    transform: "translate(55, 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 10 L 30 10 C 30 0, 40 0, 40 10 L 50 10 L 50 60 L 10 60 L 10 40 C 20 40, 20 30, 10 30 Z",
    fill: "url(#gradOrange)",
    stroke: "url(#edgeHighlight)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 30,
    r: 3,
    fill: "#FFFFFF",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 80,
    r: 2,
    fill: "#FFFFFF",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRompecabezasPremium);
export default __webpack_public_path__ + "static/media/rompecabezas_premium.d559f60071ca9c1a6b4c1c34d6bbcd11.svg";
export { ForwardRef as ReactComponent };